import { axiosClient } from "@/lib/api";

export interface PinReadinessUser {
  userId: string;
  displayName: string;
}

export interface PinReadiness {
  /** True when every active member of the nursery has a PIN (own or temporary). */
  ready: boolean;
  usersWithoutPin: PinReadinessUser[];
}

/**
 * Pre-go-live check: who in this nursery has no PIN at all? Users on
 * the list cannot log in on a shared device, so the toggle flow warns before
 * PIN login is enabled.
 */
export async function fetchPinReadiness(
  nurseryId: string,
): Promise<PinReadiness> {
  const res = await axiosClient<PinReadiness>({
    url: `/v1/nurseries/${nurseryId}/pin-readiness`,
    method: "GET",
  });
  return res.data;
}
